import { defineStore } from 'pinia'
import { useContractStore } from './contract'
import basicnet from "@/network/optional.js";
import contractnet from '@/network/contractnet'
import validation from '@/assets/js/validation'

const productionChange = require("@/models/productionChange")

export const useOperationStore = defineStore('opration', {
  state: () => {
    return {
      // 营运媒体列表
      OperationInstructions: [],
      // 换画列表
      ProductionChangeList: [],
      // 当前处理的换画
      ProductionChange: {},
      // 营运费用摘要
      OperationSummary: {},
      // 营运费用明细
      OperationSummaryDetails: [],
      //弹窗操作模式
      OperationMode: 'view',
      // 上画选项
      PostDateTypeOptions: [],
      // 下画选项
      DepostDateTypeOptions: [],
    }
  },
  getters: {
    bProdChangeDisabled (state) {
      const dateJs = require("@/assets/js/date.js").default
      return (state.OperationSummary.additionalProduction || 0) <= 0 || dateJs.DateDiff(state.OperationSummary.additionalProductionEndDate, new Date()) + 1 > 0 || state.OperationSummary.remainingBalanceAmount <= 0
    }

  },
  actions: {
    /**
     * 刷新页面
     */
    async RefreshOperation () {
      const useContract = useContractStore()
      const ContractId = useContract.Id

      // Operation Change 明细
      const operation_res = await contractnet
        .ContractOperationInstructionDetails(ContractId)
        .then((res) => res.data);
      this.OperationInstructions = operation_res;

      this.getProductionChangeSummary(ContractId)
    },
    async getProductionChangeSummary (ContractId) {
      const summary_res = await contractnet
        .getOperationSummary(ContractId)
        .then((res) => res.data);

      this.OperationSummary = summary_res.operationSummary
      this.OperationSummaryDetails = summary_res.operationSummaryDetails
    },
    async toSave () {
      for (let index = 0; index < this.OperationInstructions.length; index++) {
        await this.validate(undefined, index)
      }
      var message = this.OperationInstructions.filter(t => (t.validate || []).length > 0)?.[0]?.validate?.[0]?.message || ""
      if (message !== "") {
        return message
      }

      message = await this.SaveData().then(res => res)

      if (message === "") {
        this.RefreshOperation()
        return ""
      }

      return message
    },
    /**
     * 保存数据
     */
    async SaveData () {
      const res = await contractnet
        .saveContractOperationInstruction(this.OperationInstructions)
        .then((res) => res);
      var message = res.data.resultMessage || "";

      return message
    },
    /**
     * 当前需要处理的换画信息
     * @param {Number} index 第几个媒体
     */
    getProductionChange (index, mode) {
      this.OperationMode = mode;
      const OperationMedia = this.OperationInstructions[index]
      this.ProductionChange.mediaName = OperationMedia.mediaName;
      this.ProductionChange.quantity = OperationMedia.quantity;
      this.ProductionChange.productionDate = ""
      this.ProductionChange.productionCostType = ""
      this.ProductionChange.salesAmount = ""
      this.ProductionChange.salesAdminAmount = ""
      this.ProductionChange.id = 0
      this.ProductionChange.contractId = OperationMedia.contractId
      this.ProductionChange.contractMediaId = OperationMedia.contractMediaId
      this.ProductionChange.operationId = OperationMedia.id
      this.ProductionChange.mediaSeqNo = (index + 1)
      this.ProductionChange.remark = ""

    },
    //修改弹窗换画信息
    editProductionChange (index, mode) {
      this.OperationMode = mode;
      const data = this.OperationSummaryDetails[index];
      this.ProductionChange.id = data.id;
      this.ProductionChange.mediaSeqNo = data.mediaSeqNo;
      this.ProductionChange.contractMediaId = data.contractMediaId;
      this.ProductionChange.contractId = data.contractId;
      this.ProductionChange.operationId = data.operationId;
      this.ProductionChange.mediaName = data.mediaName;
      this.ProductionChange.quantity = data.quantity;
      this.ProductionChange.salesAmount = data.salesAmountValue;
      this.ProductionChange.salesAdminAmount = data.salesAdminAmount;
      this.ProductionChange.productionCostType = data.productionCostTypeValue;
      this.ProductionChange.productionDate = data.productionDate;
      this.ProductionChange.remark = data.remark;
    },
    /**
     * 更新上下画
     * @param {*} params 
     */
    async UpdateProductionChange () {
      const data = {
        Id: this.ProductionChange.id,
        mediaSeqNo: this.ProductionChange.mediaSeqNo,
        contractMediaId: this.ProductionChange.contractMediaId,
        operationId: this.ProductionChange.operationId,
        productionDate: this.ProductionChange.productionDate,
        productionCostType: this.ProductionChange.productionCostType,
        currency: "",
        remark: this.ProductionChange.remark,
        salesAmount: this.ProductionChange.salesAmount,
        salesAdminAmount: this.ProductionChange.salesAdminAmount,
        contractId: this.ProductionChange.contractId,
      };

      const change_res = await contractnet
        .ChangeContractProductionChange(data)
        .then((res) => res);

      var message = change_res.data.resultMessage || ""
      console.log("message 2", message)
      if (message === "") {
        this.getProductionChangeSummary(this.ProductionChange.contractId)
      }



      return message;
    },
    async getPostDateTypeOptions () {
      // 营运选项
      this.PostDateTypeOptions = await basicnet
        .getBasicOptionals("PostDateType")
        .then((res) => res.data);
    },
    async getDepostDateTypeOptions () {
      // 营运选项
      this.DepostDateTypeOptions = await basicnet
        .getBasicOptionals("DepostDateType")
        .then((res) => res.data)
    },
    async validate (type, index, action) {
      type = type || 'operation'

      const rulesJs = require("@/views/contract/js/operationRules.js")

      var source = this.OperationInstructions[index]
      var rules = rulesJs.OperationRules

      if (type === "prodchange") {
        source = this.ProductionChange
        rules = rulesJs.ProductionChangeRules
      }

      source.action = action

      source.validate = await validation.validate(source, rules).then(err => err)
    }
  }
})
